import { Language } from "typings";
import { ICommandBarItemProps, IContextualMenuItem } from "office-ui-fabric-react";

export const GetLanguageMenu = (
    languages: Language[], 
    onLanguageChange: (language: Language ) => void, 
    selectedLanguage: Language): ICommandBarItemProps [] =>
{
    const onChange = (ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item: IContextualMenuItem) =>  
    {
        onLanguageChange(item.data);
    };

    return languages.map(lang => ( 
        { 
            key:lang.name, 
            name: lang.name, 
            data: lang,
            checked: lang.name === selectedLanguage.name, 
            onClick: onChange
        }
    ));
};


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/localeTextList/languageHelper.ts